export const DEBUG = true; 
export const PATH = 'https://hatannapi.scriptales.com/'; 
// export const PATH = 'https://api.hatannapp.fr/'; 